import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseGrid"] */ "/workspace/src/components/fix-it/ExpertiseGrid.tsx");
